import { CHANGE_ORGANIZATION_SELECT, CHANGE_JIT_ORGANIZATION_SELECT } from '@app/store/constants';

export function changeOrganizationSelect(selectedOrganization: string) {
    return {
        payload: selectedOrganization,
        type: CHANGE_ORGANIZATION_SELECT
    };
}

export function changeJitOrganizationSelect(selectedOrganization: string) {
    return {
        payload: selectedOrganization,
        type: CHANGE_JIT_ORGANIZATION_SELECT
    };
}
